// #TODO 30-04-2018_FG Terminer les interfaces

import { IYii, Yii } from "libraries/interfaces/Yii";
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HelperService } from 'libraries/hotel/services/helper.service';
import { IHotel, ILoaders } from 'libraries/hotel/models/quotation';
import { IRoomDetail, IRooming } from 'libraries/hotel/models/quote';
import { DetailType, IAccommodation, IDetailsOffer, IDetailsOfferDetail, IMealplan } from 'libraries/hotel/models/details';
import { IAlternative, IHotelConfig } from 'libraries/hotel/models/hotel';
import { IOtherRoomsRequest, IQuoteRequest } from 'libraries/service/resources/hotel/ISearchParameters';
import { ICurrency } from 'libraries/service/resources/model/search/ICurrency';
import { IConfigSharedHotel } from 'libraries/hotel/models/config-shared-hotel';
import { ICurrencies, IPossibleRoom } from "libraries/service/resources/hotel/ISearchResponse";
import { ILabels } from "libraries/interfaces/ILabels";
import get from "lodash-es/get";
import { IChangeRoom } from "libraries/hotel/containers/hotels-list/services/IChangeRoom";
import { INotification, NotificationType } from "libraries/interfaces/INotification";
import { NOTIFICATIONS } from "libraries/hotel/initializer";

interface INotificationOffer extends INotification{
    host?: string;
}

class Wording {
    public readonly otherRooms: string = Yii.t('wui-iqbh-js', 'Autres chambres');
    public readonly close: string = Yii.t('wui-iqbh-js', 'Fermer');
    public readonly choose: string = Yii.t('wui-iqbh-js', 'Choisir');
    public readonly room: string = Yii.t('wui-iqbh-js', 'Chambre');
    public readonly searchingRooms: string = Yii.t('wui-iqbh-js', 'Recherche des chambres en cours');
}
@Component({
    selector: 'offers',
    template: `
        <ul *ngIf="data.selectedQuotation && data.selectedQuotation.offers.length > 0">
            <notification *ngIf="notification?.active" [type]="notification?.type">{{ notification?.message }}</notification>
            <div *ngFor="let offer of data.selectedQuotation.offers;"
                 class="list-item hoverarea">
                <div class="host-cancellation">
                    <offer class="header-room" [configSharedHotel]="configSharedHotel"
                           [isSelectedOffer]="offer.xId === data.selectedQuotation.selectedOffer"
                           [offer]="offer"
                           [currency]="currency"
                           [currencies]="currencies">
                    </offer>

                    <div class="btns hovervisible">
                        <btn *ngIf="!otherRoomsState.isOpen || otherRoomsState.host !== offer.host"
                             type="actionDo"
                             [value]="wording.otherRooms"
                             (onClick)="getOtherRooms(offer)">
                        </btn>

                        <btn *ngIf="otherRoomsState.isOpen && otherRoomsState.host === offer.host"
                             type="actionDo"
                             [value]="wording.close"
                             (onClick)="closeOtherRoomsList()">
                        </btn>

                        <btn *ngIf="!config"
                             type="actionDo"
                             [value]="wording.choose"
                             (onClick)="getQuotation(offer)">
                        </btn>
                        <btn *ngFor="let button of config?.buttons"
                             type="actionDo"
                             [value]="button.label"
                             (onClick)="button.callback ? button.callback(offer) : this[button.internalFunctionName](offer)">
                        </btn>
                    </div>
                </div>

                <notification *ngIf="secondaryNotification?.active && secondaryNotification?.host === offer.host"
                              [type]="secondaryNotification?.type">{{ secondaryNotification?.message }}
                </notification>
                <notification *ngIf="shouldDisplayMealplanWarning(offer)"
                              type="info">
                    {{ labels.pleaseChooseSameMealPlan }}
                </notification>

                <ul class="list"
                    *ngFor="let room of getAccommodations(offer); let selectedRoomIndex = index; let odd = odd; let even = even;">
                    <li *ngIf="(offer.host !== otherRoomsState.host || !data.selectedQuotation.selected === offer.xId)"
                        class="list-item offer-room selected-rooms"
                        [ngClass]="{ odd: odd, even: even }">

                        <room class="details"
                              [room]="room"
                              [configSharedHotel]="configSharedHotel"
                              [travellers]="travellers"
                              [currency]="currency"
                              [currencies]="currencies"
                              [roomNumber]="selectedRoomIndex + 1">
                        </room>
                        <div class="btns"></div>
                    </li>

                    <div *ngIf="data.selectedQuotation.rooms && offer.host === otherRoomsState.host">
                        <div class="room-number">{{ wording.room }} {{ selectedRoomIndex + 1 }}</div>
                        <li *ngFor="let otherRoom of getPossibleRooms(room.rooming, offer.host); let roomIndex = index; let odd = odd; let even = even;"
                            class="list-item offer-room selectable"
                            [ngClass]="{ odd: odd, even: even }"
                            (click)="selectRoom(room.rooming, otherRoom, offer)">
                            <room class="details"
                                  [selectedRoom]="room.xId === otherRoom.xId"
                                  [travellers]="travellers"
                                  [configSharedHotel]="configSharedHotel"
                                  [currency]="currency"
                                  [currencies]="currencies"
                                  [room]="otherRoom"
                                  [showMealPlan]="true"></room>
                            <div class="btns"
                                 (click)="selectRoom(room.rooming, otherRoom, offer)">
                            </div>
                        </li>
                    </div>
                </ul>

                <loader *ngIf="data.loaders.getOtherRooms && offer.host === otherRoomsState.host"
                        [message]="wording.searchingRooms"></loader>
            </div>
        </ul>
    `,
    styleUrls: ['./offers.component.scss']
})
export class OffersComponent implements OnInit {

    @Input()
    public otherRoomsList;

    @Input()
    public offers: IDetailsOffer[] = [];

    @Input()
    public config: IHotelConfig;

    @Input()
    public travellers: IRooming;

    @Input()
    public propertyAlternatives: IAlternative[];

    @Input()
    public isWithGiata: boolean;

    @Output()
    public readonly onGetQuotation: EventEmitter<IQuoteRequest> = new EventEmitter();

    @Output()
    public readonly onGetOtherRooms: EventEmitter<IOtherRoomsRequest> = new EventEmitter();

    @Output()
    public readonly onChangeRoom: EventEmitter<IChangeRoom> = new EventEmitter();

    @Input()
    public data: {
        loaders: ILoaders;
        selectedQuotation: IHotel;
    };

    @Input()
    public currency: ICurrency;
    @Input()
    public currencies: ICurrencies;

    @Input()
    public configSharedHotel: IConfigSharedHotel;

    public otherRoomsState: {
        host: string;
        isOpen: boolean;
    } = {
        host: null,
        isOpen: false
    };

    public labels: ILabels = {
        pleaseChooseSameMealPlan: Yii.t("wui-shared-js", "Merci de sélectionner des chambres avec la même offre de repas."),
    };

    public notification: INotificationOffer = NOTIFICATIONS;
    public secondaryNotification: INotificationOffer = NOTIFICATIONS;
    public wording: Wording = new Wording();

    constructor (
        private helperService: HelperService,
    ) {}

    public ngOnInit (): void {
        this.otherRoomsState = {
            host: null,
            isOpen: false
        };
        if(this.data && this.data.selectedQuotation && this.data.selectedQuotation.offers && this.propertyAlternatives){
            this.data.selectedQuotation.offers = this.data.selectedQuotation.offers
                .map((offer: IDetailsOffer) => ({...offer, alternatives: this.propertyAlternatives, isWithGiata: this.isWithGiata}));
        }
    }

    public getAccommodations (offer: IDetailsOffer): IAccommodation[] {
        return this.helperService.objectToArray(offer.detail)
            .filter((details: IAccommodation | IMealplan) => details.xType === 'accomodation');
    }

    public closeOtherRoomsList (): void {
        this.secondaryNotification.active = false;
        this.otherRoomsState = {
            isOpen: false,
            host: null
        };
    }

    public getRoomsArray (roomsObject): IRoomDetail[] {
        return this.helperService.objectToArray(roomsObject);
    }

    public getOtherRooms (offer: IDetailsOffer): void {
        this.otherRoomsState = {
            isOpen: true,
            host: offer.host
        };

        if (offer.host === 'EXPEDIA') {
            this.secondaryNotification = {
                type: NotificationType.Info,
                message: Yii.t('wui-iqbh-js', 'Avec EXPEDIA, le même type de chambre est requis.'),
                active: true,
                host: offer.host
            };
        } else if (this.secondaryNotification.active) {
            this.secondaryNotification.active = false;
        }

        const dateLastCancellationWithoutPenalty: string = offer.hasOwnProperty('dateLastCancellationWithoutPenalty')
                                                        ? offer.dateLastCancellationWithoutPenalty
                                                        : null;

        this.onGetOtherRooms.emit({
            properties: offer.property,
            trips: this.data.selectedQuotation.property.trip,
            hosts: offer.host,
            offerXid: offer.xId,
            dateLastCancellationWithoutPenalty
        });
    }

    public selectRoom (roomNumber: string, room: IPossibleRoom, offer: IDetailsOffer): void {
        const roomSelected: string = `accomodation_${roomNumber}`;

        const offers: IDetailsOffer[] = this.data.selectedQuotation.offers
            .map((offerDetails: IDetailsOffer): IDetailsOffer => {
                if (offer.host === 'EXPEDIA') {
                    const expediaOtherRoomsList: IDetailsOffer[] = this.otherRoomsList[offerDetails.host];
                    const details: IDetailsOfferDetail = {};
                    const offerDetailsList: Array<IAccommodation | IMealplan> = Object.values(offerDetails.detail);

                    if(expediaOtherRoomsList){
                        offerDetailsList
                            .forEach((detail: IAccommodation | IMealplan, index: number): void => {
                                // Remove the _IK_ part (traveller's distribution) to keep only the syscode and compare it
                                const selectedRoom: string = room.syscode.split("_IK_").shift();
                                const detailRoom: string = detail.syscode.split("_IK_").pop();
                                const expediaRoomFound: IAccommodation = expediaOtherRoomsList[`${selectedRoom}_IK_${detailRoom}`];

                                if (expediaRoomFound) {
                                    details[`${room.xType}_R${index+1}`] = {
                                        ...expediaRoomFound,
                                        rooming: `R${index+1}`
                                    };
                                }
                            });
                    }

                    return {
                        ...offerDetails,
                        mealplan: room.mealplan,
                        detail: {
                            ...offerDetails.detail,
                            ...details
                        }
                    };
                } else if (offerDetails.xId === offer.xId) {
                    return {
                        ...offerDetails,
                        mealplan: room.mealplan,
                        detail: {
                            ...offerDetails.detail,
                            [roomSelected]: {
                                ...room,
                                xType: DetailType.Accomodation,
                                rooming: roomNumber
                            }
                        }
                    };
                }

                return offerDetails;
            });

        this.onChangeRoom.emit({ offers, offerXid: offer.xId, host: offer.host });
    }

    public getQuotation (offer: IDetailsOffer): void {
        if (this.notification) {
            this.notification.active = false;
        }

        let canCreateQuote: boolean = true;

        if (offer.host === 'EXPEDIA') {
            canCreateQuote = Object.values(offer.detail)
               .filter((detail: IAccommodation | IMealplan) => detail.xType.toLowerCase() === DetailType.Accomodation)
               .map((detail: IAccommodation) => detail.syscode.split("_IK_").shift())
               .every((val: string, i: number, arr: string[]) => val === arr[0]);
        }

        if (canCreateQuote) {
            const quotationRequest: IQuoteRequest = {
                properties: offer.property,
                hosts: offer.host
            };

            this.onGetQuotation.emit(quotationRequest);
        } else {
            this.notification = {
                type: NotificationType.Info,
                message: Yii.t('wui-iqbh-js', 'Avec EXPEDIA, le même type de chambre est requis.'),
                active: true
            };
        }
    }

    public shouldDisplayMealplanWarning(offer: IDetailsOffer): boolean{
        if (this.data.loaders.getOtherRooms
            || !this.data.selectedQuotation.rooms
            || offer.host !== this.otherRoomsState.host
            || this.getAccommodations(offer).length < 2) {
            return false;
        }

        const rooms: IRoomDetail[] = this.data.selectedQuotation.rooms
            && this.data.selectedQuotation.rooms[offer.host]
            && this.getRoomsArray(this.data.selectedQuotation.rooms[offer.host]);

        const usedCodes: Set<string> = (rooms || [])
            .map((room: IRoomDetail) => room.mealplan && room.mealplan.xCode)
            .reduce((plans: Set<string>, code: string) => plans.add(code), new Set<string>());

        return usedCodes.size >= 2;
    }

    public getPossibleRooms(rooming: string, host: string): IPossibleRoom[]{
        const rooms: IPossibleRoom[] = Object.values(get(this.data, ["selectedQuotation", "rooms", host], {}));

        return rooms
            .filter((room: IPossibleRoom) => room.rooming && room.rooming.includes(rooming));
    }
}
